/* globals CSS_CONFIG */
import { isBrowser } from './browserHelper';
import { getQueryParamsFromURL } from './urlHelper';

export type OutgoingEventName =
  | 'BOKA/BOKA_CLOSED'
  | 'BOKA/BOOKING_COMPLETE'
  | 'BOKA/QUESTIONS_ANSWERED'
  | 'BOKA/QUESTIONS_CLOSED';

interface OutgoingMessage {
  event: OutgoingEventName;
  data?: Record<string, string | undefined>;
}

export const getTargetOrigins = (
  allowedOrigins: Record<string, string[]> = CSS_CONFIG.allowedOrigins,
): string[] => {
  const { refApp } = getQueryParamsFromURL();
  if (!refApp) return [];
  const targets = allowedOrigins[refApp] || [];
  console.log('Get target origins - refApp:', refApp, 'targets:', targets);
  return targets;
};

const isValidHttpsOrigin = (origin: string): boolean => {
  try {
    const url = new URL(origin);
    return url.protocol === 'https:' && !!url.hostname;
  } catch {
    return false;
  }
};

export const isAllowedOrigin = (
  origin: string,
  allowedOrigins: Record<string, string[]> = CSS_CONFIG.allowedOrigins,
): boolean => {
  return (
    isValidHttpsOrigin(origin) &&
    getTargetOrigins(allowedOrigins).includes(origin)
  );
};

export const sendMessageToParent = (
  eventName: OutgoingEventName,
  data?: Record<string, string | undefined>,
): void => {
  if (!isBrowser() || window.parent === window) return;
  const targetOrigins = getTargetOrigins();
  console.log('Post message - target origins:', targetOrigins);
  if (targetOrigins.length === 0) return;

  const message: OutgoingMessage = {
    event: eventName,
    data,
  };

  targetOrigins.forEach((origin) => {
    window.parent.postMessage(message, origin);
  });
};
